import React, { Fragment } from "react";

const CustomComponentField = (props) => {
  console.log(props);

  const { field, attrs, data, record } = props;
  const { name, readOnly, Component } = field;

  return (
    <Fragment>
      <Component {...props} />
    </Fragment>
  );
};

export default CustomComponentField;
